import { render, staticRenderFns } from "./tinhNang.vue?vue&type=template&id=229caeaf&scoped=true&"
import script from "./tinhNang.vue?vue&type=script&lang=js&"
export * from "./tinhNang.vue?vue&type=script&lang=js&"
import style0 from "./tinhNang.vue?vue&type=style&index=0&id=229caeaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229caeaf",
  null
  
)

export default component.exports